// Componente para envolver as rotas com os Providers necessários que dependem do Router
import {AuthProvider} from "@context/AuthProvider.tsx";
import {ApiProvider} from "@context/ApiProvider.tsx";
import {PopUpProvider} from "@context/PopUpProvider.tsx";
import {ToastContainer} from "react-toastify";
import {Layout} from "@components/default/Layout.tsx";

export const RootProvider = () => {
	return (
		<AuthProvider>
			<ApiProvider>
				<PopUpProvider>
					<ToastContainer position={'bottom-center'}
					                theme={'dark'}
					                stacked
					                autoClose={5000}
					                newestOnTop={false}
					                closeOnClick
					                pauseOnFocusLoss
					                draggable
					                pauseOnHover
					                limit={5}
					/>
					<Layout/>
				</PopUpProvider>
			</ApiProvider>
		</AuthProvider>
	);
};